import { render, staticRenderFns } from "./DxWorkOrders.vue?vue&type=template&id=257e0816&scoped=true&"
import script from "./DxWorkOrders.vue?vue&type=script&lang=js&"
export * from "./DxWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./DxWorkOrders.vue?vue&type=style&index=0&id=257e0816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e0816",
  null
  
)

export default component.exports